import Vue from 'vue'
import Router from 'vue-router'
import Menu from '@/components/Menu'
import Movie from '@/components/movie'
import Home from '@/components/home'
import Contact from '@/components/contact'
import Review from '@/components/review'
import Login from '@/components/login'
import SignUp from '@/components/signup'
import Apartment from '@/components/apartment'
import Melbourne from '@/components/melbourne'
import Sydney from '@/components/sydney'
import firebase from 'firebase'
import News from '@/components/news'
import Vedio from '@/components/vedio'
import Youtube from '@/components/youtube'
import Viewlistvedio from '@/components/viewlistvedio'
import Edititem from '@/components/edititem'
import Additem from '@/components/additem'
import Upload from '@/components/upload'
import Product from '@/components/product'
import Productbeauty from '@/components/productbeauty'
import Editproductitem from '@/components/editproductitem'
import Viewlistproduct from '@/components/viewlistproduct'
import Addproduct from '@/components/addproduct'
import Flow from '@/components/flow'
import Newshome from '@/components/newshome'
import PicZoom from '@/components/PicZoom'
import Cartitem from '@/components/cartitem'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/home'
    },
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/movie',
      name: 'Movie',
      component: Movie
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/review',
      name: 'Review',
      component: Review
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/apartment',
      name: 'Apartment',
      component: Apartment
    },
    {
      path: '/melbourne',
      name: 'Melbourne',
      component: Melbourne
    },
    {
      path: '/sydney',
      name: 'Sydney',
      component: Sydney
    },
    {
      path: '/news',
      name: 'News',
      component: News,
      props: true
    },
    {
      path: '/vedio',
      name: 'Vedio',
      component: Vedio,
      props: true
    },
    {
      path: '/youtube',
      name: 'Youtube',
      component: Youtube,
      props: true
    },
    {
      path: '/viewlistvedio',
      name: 'ViewlistVedio',
      component: Viewlistvedio,
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/edititem',
      name: 'Edit',
      component: Edititem,
      props: true
    },
    {
      path: '/additem',
      name: 'Add',
      component: Additem,
      props: true
    },
    {
      path: '/upload',
      name: 'Upload',
      component: Upload
    },
    {
      path: '/product',
      name: 'Product',
      component: Product,
      props: true
    },
    {
      path: '/productbeauty',
      name: 'Productbeauty',
      component: Productbeauty,
      props: true
    },
    {
      path: '/editproductitem',
      name: 'Editproductitem',
      component: Editproductitem,
      props: true
    },
    {
      path: '/viewlistproduct',
      name: 'Viewlistproduct',
      component: Viewlistproduct
    },
    {
      path: '/addproduct',
      name: 'Addproduct',
      component: Addproduct,
      props: true
    },
    {
      path: '/flow',
      name: 'Flow',
      component: Flow,
      props: true
    },
    {
      path: '/newshome',
      name: 'Newshome',
      component: Newshome,
      props: true
    },
    {
      path: '/',
      name: 'PicZoom',
      component: PicZoom
    },
    {
      path: '/cartitem',
      name: 'Cartitem',
      component: Cartitem
    }
  ]
})


router.beforeEach((to, from, next) => {
  
  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  
  if (requiresAuth && !currentUser) 
    { 
      alert('Please Login or Sigup!');
      next('login')
    }
  else if (requiresAuth && currentUser && !currentUser.emailVerified)   
    {
      alert('Your email is not verified, Please login via received mail from wewamart.com');
      next('home')
    }
  else if (!requiresAuth && currentUser) next() 
  else next()
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js